// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1B_T5","messages":"Chat_messages__2oE4N","dateDivider":"Chat_dateDivider__7IcoC"};